import React from 'react';
import ProjectPage from '../../components/projects/ProjectPage';
import paradiseParkData from '../../data/projects/paradisepark.js';

function ParadisePark() {
  return <ProjectPage projectData={paradiseParkData} />;
}

export default ParadisePark;

